<!-- eslint-disable no-undef -->
<!-- eslint-disable no-undef -->
<template>
  <v-app v-if="!scanningQRCode" style="overflow: hidden;">
    <v-app-bar
      app
      flat
      v-if="processDisplaySystem !== null && !loading"
      fillwidth
      :color="noNetwork ? 'red' : ''"
    >
      <v-btn icon>
        <v-img max-width="30" src="https://cdn.salescloud.is/logo_white.svg" />
      </v-btn>
      <v-toolbar-title class="pl-1 font-weight-bold mr-3">
        {{ processDisplaySystem.title }}
      </v-toolbar-title>
      <v-progress-circular
        v-if="processing || socketClientState === null"
        indeterminate
        size="14"
        width="2"
        class="mr-2"
      ></v-progress-circular>
      <v-icon v-else-if="socketClientState === 'connected'" class="mr-2">mdi-cloud-check</v-icon>
      <v-icon v-else-if="socketClientState === 'closed'" class="mr-2">mdi-cloud-off-outline</v-icon>
      <v-icon v-else-if="socketClientState === 'error'" class="mr-2">mdi-cloud-error-outline</v-icon>
      <v-icon v-else-if="socketClientState === 'connecting'" class="mr-2">mdi-cloud-sync-outline</v-icon>
      <v-spacer />
      <v-icon v-if="!noNetwork">mdi-wifi</v-icon>
      <v-icon v-if="noNetwork">mdi-wifi-off</v-icon>
      <template v-if="showBatteryLevel">
        <v-icon :color="batteryLevel <= 0.1 ? 'error' : 'warning'" class="mr-2">mdi-alert-circle</v-icon>
        <div class="mr-3 font-weight-medium">Low battery</div>
      </template>

      <v-btn text class="mr-2">{{ currentTime }}</v-btn>
      <v-btn
        key="supportButton"
        class="mr-3"
        @click="openSupportdialog = true"
        depressed
        icon
      >
        <v-icon>mdi-lifebuoy</v-icon>
      </v-btn>
      <v-btn
        class="mr-2"
        key="settingsButton"
        @click="showSettingsDialog = true"
        depressed
        icon
      >
        <v-icon>mdi-cog</v-icon>
      </v-btn>
      <v-btn
        class="mr-2"
        key="refreshButton"
        @click="refresh"
        :disabled="isButtonDisabled('refreshButton')"
        :loading="isButtonLoading('refreshButton')"
        depressed
        icon
      >
        <v-icon>mdi-reload</v-icon>
      </v-btn>
      <v-btn
        key="restartButton"
        @click="restart"
        :disabled="restarting"
        :loading="restarting"
        depressed
        icon
      >
        <v-icon>mdi-restart</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main class="pb-12 mb-12" fillwidth>
      <v-dialog
        v-model="openSupportdialog"
        max-width="400"
      >
        <v-card align="center">
        <v-card-title  class="text-h5 justify-center pa-3"> SalesCloud Support </v-card-title >
        <v-card-text>If you have a question or issues with your Kitchen display system, please contact</v-card-text>
        <v-card-text>+354 421 1080</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            @click="openSupportdialog = false"
            block
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
      </v-dialog>
      <v-dialog v-if="showSettingsDialog" v-model="showSettingsDialog">
        <SettingsCard @closed="showSettingsDialog = false" />
      </v-dialog>
      <v-dialog v-model="showNoNetwork" max-width="500">
        <v-card>
          <v-card-text
            class="pa-8"
            style="text-align: center"
          >
            <div>
              <v-icon
                class="mb-2"
                x-large
                circle
              >
                mdi-wifi-off
              </v-icon>
            </div>
            <div class="title">
              It appears that Wi-Fi is not connected
            </div>
            <div
              class="subtitle-1 mb-3"
            >
              Please make sure that Wi-Fi is on and connected
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-container fluid class="pa-0">
        <v-row>
          <v-col cols="12">
            <div v-if="loading" class="text-center pa-6">
              <v-progress-circular
                :size="70"
                :width="7"
                color="primary"
                indeterminate
              />
            </div>
            <template
              v-else-if="message"
            >
              <InfoCard :type="errorType" :title="message" :subtitle="subMessage" />
              <div v-if="showQrButton" center="center" align="center">
                <v-btn
                  max-width="600px"
                  class="mt-3"
                  @click="openCamera"
                  v-if="organization === null || organization === undefined"
                >
                  Scan QR Code
                </v-btn>
              </div>
            </template>
            <Orders
              v-else-if="organization !== null && showSelectedStates"
              :orders="ordersInStates"
            />
            <Orders
              v-else-if="organization !== null && !showSelectedStates"
              :orders="ordersOthers"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <div
      v-if="organization !== null && !loading"
      class="pa-0"
      style="width: 100%; position: fixed; bottom: 0; left: 0;"
    >
      <v-row no-gutters>
        <!-- <v-col v-show="selectedOrders.length > 0" cols="3">
          <v-btn
            @click="recedeSelectedOrderStates"
            key="recedeSelectedOrdersButton"
            :disabled="isButtonDisabled('recedeSelectedOrdersButton')"
            :loading="isButtonLoading('recedeSelectedOrdersButton')"
            color="black"
            class="py-6 white--text"
            block
            tile
          >
            Send back
          </v-btn>
        </v-col>
        <v-col v-show="selectedOrders.length > 0" cols="3">
          <v-btn
            @click="deselectAllOrders"
            key="deselectAllOrdersButton"
            :disabled="isButtonDisabled('deselectAllOrdersButton')"
            :loading="isButtonLoading('deselectAllOrdersButton')"
            color="error"
            class="py-6 white--text"
            block
            tile
          >
            Deselect
          </v-btn>
        </v-col>
        <v-col v-show="selectedOrders.length > 0" cols="6">
          <v-btn
            @click="proceedSelectedOrderStates"
            key="proceedSelectedOrdersButton"
            :disabled="isButtonDisabled('proceedSelectedOrdersButton')"
            :loading="isButtonLoading('proceedSelectedOrdersButton')"
            color="success"
            class="py-6 white--text"
            block
            tile
          >
            Send to next step
          </v-btn>
        </v-col> -->

        <v-col
          v-for="(button, index) in footerButtons"
          :key="index"
        >
          <v-btn
            :color="timeUntilInMillis >= button.key && button.key !== 0 ? 'black' : primaryColor"
            @click="timeUntilInMillis = button.key"
            dark
            class="py-6"
            block
            tile
          >
            {{ button.label }}
          </v-btn>
        </v-col>
        <v-col>
          <v-btn
            @click="showSelectedStates = !showSelectedStates"
            dark
            class="py-6"
            block
            tile
          >
            {{ showSelectedStates ? 'View other states' : 'View default states'}}
          </v-btn>
        </v-col>
      </v-row>

      <v-row v-if="!showSelectedStates" no-gutters>
        <div
          v-if="organization !== null"
          style="width: 100%; bottom: 0; left: 0; background-color: red; text-align: center;"
          class="d-inline pt-1 pb-1"
        >
        <v-toolbar-title>
          <b>
            You Are Viewing Other States!
          </b>
          <v-icon
            dark
            left
            class="pl-3"
            size="30"
            @click="showSelectedStates = !showSelectedStates"
          >
            mdi-undo
          </v-icon>
        </v-toolbar-title>
        </div>
      </v-row>
    </div>
  </v-app>
</template>

<script>
  import Bugsnag from '@bugsnag/js'
	import Orders from './components/Orders';
	// import LineItemsSummary from "./components/LineItemsSummary";
	import InfoCard from "./components/InfoCard";
	import SettingsCard from "./components/settings/SettingsCard";
  import { BarcodeScanner } from '@capacitor-community/barcode-scanner';
  import { KeepAwake } from '@capacitor-community/keep-awake';
  import { NativeAudio } from '@capacitor-community/native-audio';
  import { Preferences } from '@capacitor/preferences';
  import { Network } from '@capacitor/network';
  import { Device } from '@capacitor/device';
  import { App } from '@capacitor/app';


  export default {
		name: 'App',
		components: {
			SettingsCard,
			InfoCard,
			Orders,
		},
		data() {
			return {
        periodicalProcessDisplaySytemIntervalId: null,
        checkBatteryStatusIntervalId: null,
        checkTimeIntervalId: null,
        appInfo: null,
        restarting: false,
        loading: true,
        currentTime: '',
        showQrButton: false,
        showNoNetwork: false,
        noNetwork: false,
        message: null,
        subMessage: null,
        errorType: null,
        batteryLevel: null,
        showBatteryLevel: false,
				showSettingsDialog: false,
				footerButtons: [
					{
						label: '15 min',
						key: 900000
					},
					{
						label: '30 min',
						key: 2000000
					},
					{
						label: '1 hour',
						key: 3800000
					},
					{
						label: '2 hours',
						key: 7600000
					},
					{
						label: 'All',
						key: 0
					}
				],
				timeUntilInMillis: 0,
				disabledElements: [],
				loadingElements: [],
        showSelectedStates: true,
        scanningQRCode: false,
        openSupportdialog: false
			}
		},
		computed: {
      socketClientState() {
        return this.$store.state.socketClientState
      },
			processDisplaySystem() {
				return this.$store.state.processDisplaySystem
			},
      processing() {
        return this.$store.state.processing
      },
			appLoading() {
				return this.$store.state.appLoading
			},
			orderStates() {
				return this.$store.state.orderStates
			},
			selectedStates() {
				return this.$store.getters.selectedStates
			},
			orders() {        
				return this.$store.state.orders
			},
      posOrders() {
        return this.$store.state.posOrders
			},
			ordersInStates() {

        /*

				let filteredOnlineOrders = orders.filter(order => {
					return order !== null && typeof order !== 'undefined' && this.selectedStates.includes(order.state) && (order.pickupTime < (Date.now() + this.timeUntilInMillis) || this.timeUntilInMillis === 0)
				})

        filteredOnlineOrders = filteredOnlineOrders.sort(function(a, b) {
          return a.created - b.created
        })


        let filteredPosOrders = this.posOrders.filter(order => {
					return order !== null && typeof order !== 'undefined' && this.selectedStates.includes(order.state)
				})

        filteredPosOrders = filteredPosOrders.sort(function(a, b) {
          return a.created - b.created
        })

        */

        if(this.processDisplaySystem !== null && this.processDisplaySystem !== undefined && this.processDisplaySystem.organization.uuid === '96c26d7b-1595-4d46-9c44-d12fe906a3b9') {
          return this.posOrders.filter(order => order && this.selectedStates.includes(order.state) && order.lineItems !== null && order.lineItems !== undefined && order.lineItems.length > 0 && order.lineItems.some(lineItem => lineItem.printed) && this.hasCategory(order.lineItems, '9934a89b-39b6-44a6-a3a9-3b5abe5d6dbb'))
        }

        const ordersInState = this.orders.filter(order => order && this.selectedStates.includes(order.state) && order.lineItems !== null && order.lineItems !== undefined && order.lineItems.length > 0)

        const posOrders = this.posOrders.filter(order => order && this.selectedStates.includes(order.state) && order.lineItems !== null && order.lineItems !== undefined && order.lineItems.length > 0)

        const totalOrders = ordersInState.concat(posOrders)

        // Filter out orders that do not beling to the location

        totalOrders.sort(this.sortOrders)

        return totalOrders
      },
      ordersOthers() {
        const ordersInState = this.orders.filter(order => !this.selectedStates.includes(order.state) && order.lineItems !== null && order.lineItems !== undefined && order.lineItems.length > 0)

        const posOrders = this.posOrders.filter(order => !this.selectedStates.includes(order.state) && order.lineItems !== null && order.lineItems !== undefined && order.lineItems.length > 0)

        const totalOrders = ordersInState.concat(posOrders)

        totalOrders.sort(this.sortOrders)

        return totalOrders
      },
			selectedOrders() {
				return this.$store.state.selectedOrders
			},
			organization() {
				return this.$store.state.organization
			},
			primaryColor() {

				if(this.organization === null) {
					return '#2277dd'
				}

				return this.organization.primary_color
			}
		},
    watch: {
      processDisplaySystem(newProcessDisplaySystem) {

        if(newProcessDisplaySystem !== null && newProcessDisplaySystem !== undefined && newProcessDisplaySystem.location !== null && newProcessDisplaySystem.location !== undefined && newProcessDisplaySystem.location.timezone !== null && newProcessDisplaySystem.location.timezone !== undefined) {
          this.$moment.tz.setDefault(newProcessDisplaySystem.location.timezone);
        }

        if(newProcessDisplaySystem !== null && newProcessDisplaySystem !== undefined && newProcessDisplaySystem.darkMode !== null) {
          this.$vuetify.theme.dark = newProcessDisplaySystem.darkMode
        }
      }
    },
		methods: {
      sortOrders: (order1,order2) => {

          const payment1 = order1.payments.find(payment => payment && payment.status === 'success')
          const payment2 = order2.payments.find(payment => payment && payment.status === 'success')
          let created1 = order1.created
          let created2 = order2.created

          if(payment1) {
            created1 = payment1.created
          }
          if(payment2) {
            created2 = payment2.created
          }

          if(order1.deliveryTimeInMillis !== null && order1.deliveryTimeInMillis !== undefined && order1.deliveryTimeInMillis > 0) {
            created1 = order1.deliveryTimeInMillis
          }

          if(order2.deliveryTimeInMillis !== null && order2.deliveryTimeInMillis !== undefined && order2.deliveryTimeInMillis > 0) {
            created2 = order2.deliveryTimeInMillis
          }

          return created1 - created2
      },
      async setInitialData (uuid) {
        this.$store.commit('updatePDSUUID', uuid)

        await Preferences.set({
          key: 'salescloud:kds:pdsuuid',
          value: uuid
        });

        this.$store.dispatch('logMessage', {
          message: 'App.vue: setInitialData() called'
        })
      },
      async checkPermission() {
        // check if user already granted permission
        const status = await BarcodeScanner.checkPermission({ force: false })

        if (status.granted) {
          // user granted permission
          return true;
        }

        if (status.denied) {
          // user denied permission
          return false;
        }

        // user has not denied permission
        // but the user also has not yet granted the permission
        // so request it
        const statusRequest = await BarcodeScanner.checkPermission({ force: true });

        if (statusRequest.granted) {
          // the user did grant the permission now
          return true;
        }

        // user did not grant the permission, so he must have declined the request
        return false;
      },
      async openCamera() {
        const permission = await this.checkPermission()

        if (permission) {

          this.scanningQRCode = true
          BarcodeScanner.hideBackground()
          const result = await BarcodeScanner.startScan()

          if (result.hasContent) {
            // Stop the scan here
            this.scanningQRCode = false
            BarcodeScanner.showBackground()
            BarcodeScanner.stopScan()

            this.loading = true
            await this.setInitialData(result.content)
            await this.initialize()
            this.loading = false
          }
        }

        this.$store.dispatch('logMessage', {
          message: 'App.vue: openCamera() called'
        })
      },
      hasCategoryThatIsNot(lineItems, title) {
        let hasCategoryThatIsNot = false

        for(let i in lineItems) {
          const lineItem = lineItems[i]
          if(lineItem !== null && lineItem !== undefined && lineItem.item !== null && lineItem.item !== undefined && lineItem.item.categories !== null && lineItem.item.categories !== undefined && lineItem.item.categories.length > 0) {
            for(let n in lineItem.item.categories) {
              const category = lineItem.item.categories[n]
              if(category !== null && category !== undefined && category.name !== null && category.name !== undefined && !category.name.toLowerCase().includes(title.toLowerCase())) {
                hasCategoryThatIsNot = true
              }
            }
          }
        }

        return hasCategoryThatIsNot
      },
      hasCategory(lineItems, uuid) {
        let hasCategory = false

        for(let i in lineItems) {
          const lineItem = lineItems[i]
          if(lineItem !== null && lineItem !== undefined && lineItem.item !== null && lineItem.item !== undefined && lineItem.item.categories !== null && lineItem.item.categories !== undefined && lineItem.item.categories.length > 0) {
            for(let n in lineItem.item.categories) {
              const category = lineItem.item.categories[n]
              if(category !== null && category !== undefined && category.name !== null && category.name !== undefined && category.uuid === uuid) {
                hasCategory = true
              }
            }
          }
        }

        return hasCategory
      },
      setTime() {
        var d = new Date()
        var s = d.getSeconds()
        var m = d.getMinutes()
        var h = d.getHours()
        this.currentTime = ("0" + h).substr(-2) + ":" + ("0" + m).substr(-2) + ":" + ("0" + s).substr(-2)
      },
      restart() {
        this.restarting = true
        Bugsnag.addMetadata('state', this.$store.state)
        Bugsnag.notify(new Error('User is restarting kds'))
        Bugsnag.clearMetadata('state')
        setTimeout(() => {
          window.location.reload(true)
        }, 5000)
        this.$store.dispatch('logMessage', {
          message: 'App.vue: restart() called'
        })
      },
      setInfo(message, subMessage, errorType) {
        this.message = message
        this.subMessage = subMessage
        this.errorType = errorType
      },
      checkBatteryStatus() {
        // Runs on a 5-second setInterval — intentionally NOT dispatched as a
        // Sentry breadcrumb. The breadcrumb ring buffer holds ~100 entries,
        // so a per-5-second entry would evict the WebSocket lifecycle trail
        // we're trying to preserve in well under 10 minutes.
        return Device.getBatteryInfo().then(info => {
          this.batteryLevel = info.batteryLevel
          this.showBatteryLevel = info.batteryLevel <= 0.15 && !info.isCharging
        }).catch(() => {

        })
      },
			deselectAllOrders() {
				this.$store.commit('deselectAllOrders')
			},
			proceedSelectedOrderStates() {
				this.disabledElements.push('recedeSelectedOrdersButton')
				this.disabledElements.push('deselectAllOrdersButton')
				this.disabledElements.push('proceedSelectedOrdersButton')
				this.loadingElements.push('proceedSelectedOrdersButton')

				this.$store.dispatch('moveSelectedOrderStates', 'forward').finally(() => {
					this.disabledElements = []
					this.loadingElements = []
					this.deselectAllOrders()
				})
			},
			recedeSelectedOrderStates() {
				this.disabledElements.push('recedeSelectedOrdersButton')
				this.disabledElements.push('deselectAllOrdersButton')
				this.disabledElements.push('proceedSelectedOrdersButton')
				this.loadingElements.push('recedeSelectedOrdersButton')

				this.$store.dispatch('moveSelectedOrderStates', 'backward').finally(() => {
					this.disabledElements = []
					this.loadingElements = []
					this.deselectAllOrders()
				})
			},
			isButtonDisabled(key) {
				return this.disabledElements.findIndex(el => el === key) !== -1
			},
			isButtonLoading(key) {
				return this.loadingElements.findIndex(el => el === key) !== -1
			},
			refresh() {
				this.disabledElements.push('refreshButton')
				this.loadingElements.push('refreshButton')
				this.$store.dispatch('getOrderData').finally(() => {
					setTimeout(() => {
						this.disabledElements = []
						this.loadingElements = []
					}, 300)
				})
        this.$store.dispatch('logMessage', {
          message: 'App.vue: refresh() called'
        })
			},
      async initialize() {
        this.$store.dispatch('logMessage', {
          message: 'App.vue: initialize() called'
        })
        this.setInfo(null, null, null)
        const searchParams = new URLSearchParams(window.location.search)
        let uuid = searchParams.get('uuid')

        if (uuid === null || uuid === undefined) {
          // Try to get UUID from Capacitor Prefrences, if not, then use camera on QR code
          const uuidData = await Preferences.get({key: "salescloud:kds:pdsuuid"})

          if (uuidData.value) {
            uuid = uuidData.value
          }

          const uuidLocalValue = localStorage.getItem("salescloud:kds:pdsuuid")

          if (uuidLocalValue && !uuidData.value) {
            Preferences.set({key: "salescloud:kds:pdsuuid", value: uuidLocalValue })
            localStorage.removeItem("salescloud:kds:pdsuuid")
            uuid = uuidLocalValue
          }
        }

        if (typeof uuid !== 'undefined' && uuid !== null) {
          this.$store.commit('updatePDSUUID', uuid)
          try {
            await this.$store.dispatch('getInitialData')

            if(this.checkTimeIntervalId !== null && this.checkTimeIntervalId !== undefined) {
              clearInterval(this.checkTimeIntervalId)
            }

            this.checkTimeIntervalId = setInterval(this.setTime, 1000)

            if(this.checkBatteryStatusIntervalId !== null && this.checkBatteryStatusIntervalId !== undefined) {
              clearInterval(this.checkBatteryStatusIntervalId)
            }

            this.checkBatteryStatusIntervalId = setInterval(this.checkBatteryStatus, 5000)
            // Periodically fetches process display initial data (every hour)
            const processDisplayDataFetchInterval = 1000 * 60 * 60

            if(this.periodicalProcessDisplaySytemIntervalId !== null && this.periodicalProcessDisplaySytemIntervalId !== undefined) {
              clearInterval(this.periodicalProcessDisplaySytemIntervalId)
            }

            this.periodicalProcessDisplaySytemIntervalId = setInterval(this.periodicallyFetchProcessDisplayData, processDisplayDataFetchInterval)
          } catch(e) {
            this.setInfo('Display screen not found', 'Error fetching App data', 'error')
            this.showQrButton = true
            Bugsnag.notify(e)
          }
          return
        }
        this.setInfo('Display screen not found', 'Error initializing App', 'error')
        this.showQrButton = true
      },
      periodicallyFetchProcessDisplayData() {
        this.$store.dispatch('logMessage', {
          message: 'App.vue: periodicallyFetchProcessDisplayData() called'
        })

        return this.$store.dispatch('getProcessDisplayData')
      }
		},
		async mounted() {
      this.$store.dispatch('logMessage', {
        message: 'App.vue: mounted() called'
      })

      try {
        const kdsFromLocalStorage = localStorage.getItem("salescloud:kds:object")
        if(typeof kdsFromLocalStorage !== 'undefined' && kdsFromLocalStorage !== null) {
          const parsedLocalStorage = JSON.parse(kdsFromLocalStorage)
          this.$store.commit('setProcessDisplaySystem', parsedLocalStorage)
          if(parsedLocalStorage !== null && parsedLocalStorage !== undefined && parsedLocalStorage.location !== null && parsedLocalStorage.location !== undefined && parsedLocalStorage.location.timezone !== null && parsedLocalStorage.location.timezone !== undefined) {
            this.$moment.tz.setDefault(parsedLocalStorage.location.timezone);
          }
        }
      } catch(e) {
        // Do nothing
        Bugsnag.notify(e)
      }

      Network.addListener('networkStatusChange', status => {
        if(status.connected === false) {
          this.showNoNetwork = true
          this.noNetwork = true
        } else {
          this.showNoNetwork = false
          this.noNetwork = false
          this.initialize()
          this.$store.dispatch('logMessage', {
            message: 'App.vue: mounted() -> networkStatusChange called'
          })
        }
      });

      const status = await Network.getStatus();
      if(status.connected === false) {
        this.showNoNetwork = true
        this.noNetwork = true
      } else {
        await this.initialize()
      }

      try {
        KeepAwake.keepAwake().then().catch();
      } catch(e) {
        // Do nothing
      }

      try {
        await NativeAudio.preload({
          assetId: "ding",
          assetPath: "public/messenger-sound.mp3",
          audioChannelNum: 1,
          isUrl: false
        })
      } catch(e) {
        // Do nothing
      }

      try {
       await NativeAudio.preload({
          assetId: "ding2",
          assetPath: "public/chord.mp3",
          audioChannelNum: 1,
          isUrl: false
        })
      } catch(e) {
        // Do nothing
      }

      try {
        const appInfo = await App.getInfo()
        this.appInfo = appInfo
      } catch(e) {
        // Do nothing
      }

      this.loading = false
      this.$vuetify.theme.dark = true
		}
	};
</script>
